import React, { useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  TextField,
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  Checkbox,
  Collapse,
  RadioGroup,
  Radio,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from '@material-ui/core';
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons';
import messages from 'containers/PreOpeningPage/messages';
import { translate, arrayTranslate } from 'containers/services/translate';
import { CLAIM, CLAIM_STATUS } from 'containers/data-structure';
import { find, get, isEmpty } from 'lodash';
import { Listings, Config, SagisConfig } from 'containers/AppContainer/typings';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import { displayErrorText } from 'containers/services/validateForm';
import { SCALE_CASES_KEY } from 'containers/RecapManagerPage/constants';
import { GridWrapper } from 'containers/PreOpeningPage/ClaimInformation/style';
import { Container } from 'containers/PreOpeningPage/styled-component';
import useDeepCompareEffect from 'use-deep-compare-effect';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export interface LawyerClaimCircumstancesProps {
  intl: IntlShape;
  updateFilde?: Function;
  claimToPreopen: any;
  inputProps?: any;
  disableInput?: boolean;
  inputLabelProps?: boolean;
  listings?: Listings;
  storedClaimToPreopen?: any;
  setClaimRecap?: Function;
  claimCircumstancesValidation?: any;
  isRecapPage: boolean;
  isManager?: boolean;
  isReadOnly: boolean;
  isLawyer?: boolean;
  setDataClaimToUpdate?: Function;
  dataClaimToUpdate?: any;
  isCourtManager?: boolean;
  isOpeningManager?: boolean;
}
const LawyerClaimCircumstances: React.FC<LawyerClaimCircumstancesProps> = (
  props,
): JSX.Element => {
  const isRejected =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.REJECTED;
  const isValidated =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.VALIDATED;
  const [isScaleCaseOther, updateIsScaleCaseOther] = useState(false);
  const inputLabel = React.useRef<HTMLLabelElement>(null);

  const getCircumstances = () => {
    let circumstances = get(props.listings, 'circumstance', []).filter(
      (circumstance: SagisConfig) =>
        circumstance.ItemGroup === claimToPreopen[CLAIM.SCALE_CASE_KEY],
    );

    return circumstances;
  };

  let valueStoredClaimToPreopen = !isEmpty(props.storedClaimToPreopen)
    ? { ...props.storedClaimToPreopen }
    : props.claimToPreopen;

  const { claim } = valueStoredClaimToPreopen;

  const [claimToPreopen, updateClaim] = useState({ ...claim });

  useDeepCompareEffect(() => {
    props.setDataClaimToUpdate &&
      props.setDataClaimToUpdate({
        ...props.dataClaimToUpdate,
        claim: {
          ...get(props.dataClaimToUpdate, 'claim', {}),
          [CLAIM.IS_JUDICIAL_PROCEDURE]:
            claimToPreopen[CLAIM.IS_JUDICIAL_PROCEDURE] === CHOICE.YES,
          [CLAIM.JUDICIAL_PROCEDURE_ID]:
            claimToPreopen[CLAIM.JUDICIAL_PROCEDURE_ID],
          [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]:
            claimToPreopen[CLAIM.ACCIDENT_CIRCONSTANCE_KEY],
          [CLAIM.ACCIDENT_CIRCONSTANCE]:
            claimToPreopen[CLAIM.ACCIDENT_CIRCONSTANCE],
          [CLAIM.RESPONSABILITY_KEY]: claimToPreopen[CLAIM.RESPONSABILITY_KEY],
          [CLAIM.RESPONSABILITY_SHARE]:
            claimToPreopen[CLAIM.RESPONSABILITY_SHARE],
          [CLAIM.SCALE_CASE_KEY]: claimToPreopen[CLAIM.SCALE_CASE_KEY],
          [CLAIM.ACCIDENT_DESCRIPTION]:
            claimToPreopen[CLAIM.ACCIDENT_DESCRIPTION],
        },
      });
  }, [claimToPreopen]);

  const handleChange = (field: string) => (
    event: React.ChangeEvent<{ name?: string; value: any }>,
  ) => {
    const { value } = event.target;

    switch (field) {
      case CLAIM.IS_JUDICIAL_PROCEDURE:
        updateClaim({
          ...claimToPreopen,
          [CLAIM.IS_JUDICIAL_PROCEDURE]: value,
        });
        props.setDataClaimToUpdate &&
          props.setDataClaimToUpdate({
            ...props.dataClaimToUpdate,
            claim: {
              ...get(props.dataClaimToUpdate, 'claim', {}),
              [CLAIM.IS_JUDICIAL_PROCEDURE]:
                claimToPreopen[CLAIM.IS_JUDICIAL_PROCEDURE] === CHOICE.YES,
            },
          });
        break;
      case CLAIM.JUDICIAL_PROCEDURE_ID:
        updateClaim({
          ...claimToPreopen,
          [CLAIM.JUDICIAL_PROCEDURE_ID]: parseInt(value),
        });
        props.setDataClaimToUpdate &&
          props.setDataClaimToUpdate({
            ...props.dataClaimToUpdate,
            claim: {
              ...get(props.dataClaimToUpdate, 'claim', {}),
              [CLAIM.JUDICIAL_PROCEDURE_ID]:
                claimToPreopen[CLAIM.JUDICIAL_PROCEDURE_ID],
            },
          });
        break;
      case CLAIM.SCALE_CASE_KEY:
        updateClaim({
          ...claimToPreopen,
          [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]: '',
          [CLAIM.ACCIDENT_CIRCONSTANCE]: '',
          [CLAIM.RESPONSABILITY_KEY]: '',
          [CLAIM.RESPONSABILITY_SHARE]: null,
          [CLAIM.SCALE_CASE_KEY]: value,
        });
        props.setDataClaimToUpdate &&
          props.setDataClaimToUpdate({
            ...props.dataClaimToUpdate,
            claim: {
              ...get(props.dataClaimToUpdate, 'claim', {}),
              [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]: '',
              [CLAIM.ACCIDENT_CIRCONSTANCE]: '',
              [CLAIM.RESPONSABILITY_KEY]: '',
              [CLAIM.RESPONSABILITY_SHARE]: null,
              [CLAIM.SCALE_CASE_KEY]: value,
            },
          });
        if (value === SCALE_CASES_KEY.OTHER) {
          updateIsScaleCaseOther(true);
        } else {
          updateIsScaleCaseOther(false);
        }
        break;
      case CLAIM.ACCIDENT_CIRCONSTANCE_KEY: {
        const expectedCircumstance = get(
          props.listings,
          'circumstance',
          [],
        ).find((circumstance: SagisConfig) => circumstance.ItemKey === value);
        const responsability = find(
          get(props.listings, 'responsability'),
          (element: { ItemKey: any }) =>
            element.ItemKey === claimToPreopen[CLAIM.RESPONSABILITY_KEY],
        );
        updateClaim({
          ...claimToPreopen,
          [CLAIM.ACCIDENT_CIRCONSTANCE]: '',
          [CLAIM.RESPONSABILITY_KEY]: '',
          [CLAIM.RESPONSABILITY_SHARE]: null,
          [CLAIM.RESPONSABILITY_KEY]: expectedCircumstance
            ? expectedCircumstance.responsablityRateCode
            : '',
          [CLAIM.RESPONSABILITY_SHARE]: get(
            responsability,
            'ItemDescription',
            null,
          ),
          [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]: value,
        });
        props.setDataClaimToUpdate &&
          props.setDataClaimToUpdate({
            ...props.dataClaimToUpdate,
            claim: {
              ...get(props.dataClaimToUpdate, 'claim', {}),
              [CLAIM.ACCIDENT_CIRCONSTANCE]: '',
              [CLAIM.RESPONSABILITY_KEY]: '',
              [CLAIM.RESPONSABILITY_SHARE]: null,
              [CLAIM.RESPONSABILITY_KEY]: expectedCircumstance
                ? expectedCircumstance.responsablityRateCode
                : '',
              [CLAIM.RESPONSABILITY_SHARE]: get(
                responsability,
                'ItemDescription',
                null,
              ),
              [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]: value,
            },
          });
        if (isScaleCaseOther) {
          updateClaim({
            ...{
              ...claimToPreopen,
              [CLAIM.ACCIDENT_CIRCONSTANCE]: '',
              [CLAIM.RESPONSABILITY_KEY]: '',
              [CLAIM.RESPONSABILITY_SHARE]: null,
              [CLAIM.RESPONSABILITY_KEY]: expectedCircumstance
                ? expectedCircumstance.responsablityRateCode
                : '',
              [CLAIM.RESPONSABILITY_SHARE]: get(
                responsability,
                'ItemDescription',
                null,
              ),
              [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]: value,
            },
            [CLAIM.ACCIDENT_CIRCONSTANCE]: expectedCircumstance
              ? expectedCircumstance.ItemDescription
              : '',
          });
          props.setDataClaimToUpdate &&
            props.setDataClaimToUpdate({
              ...props.dataClaimToUpdate,
              claim: {
                ...{
                  ...get(props.dataClaimToUpdate, 'claim', {}),
                  [CLAIM.ACCIDENT_CIRCONSTANCE]: '',
                  [CLAIM.RESPONSABILITY_KEY]: '',
                  [CLAIM.RESPONSABILITY_SHARE]: null,
                  [CLAIM.RESPONSABILITY_KEY]: expectedCircumstance
                    ? expectedCircumstance.responsablityRateCode
                    : '',
                  [CLAIM.RESPONSABILITY_SHARE]: get(
                    responsability,
                    'ItemDescription',
                    null,
                  ),
                  [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]: value,
                },
                [CLAIM.ACCIDENT_CIRCONSTANCE]: expectedCircumstance
                  ? expectedCircumstance.ItemDescription
                  : '',
              },
            });
        }
        break;
      }
      case CLAIM.RESPONSABILITY_KEY:
        const responsability = find(
          get(props.listings, 'responsability'),
          (element: { ItemKey: any }) =>
            element.ItemKey === claimToPreopen[CLAIM.RESPONSABILITY_KEY],
        );
        updateClaim({
          ...claimToPreopen,
          [CLAIM.RESPONSABILITY_KEY]: value,
          [CLAIM.RESPONSABILITY_SHARE]: get(
            responsability,
            'ItemDescription',
            null,
          ),
        });
        props.setDataClaimToUpdate &&
          props.setDataClaimToUpdate({
            ...props.dataClaimToUpdate,
            claim: {
              ...get(props.dataClaimToUpdate, 'claim', {}),
              [CLAIM.RESPONSABILITY_KEY]: value,
              [CLAIM.RESPONSABILITY_SHARE]: get(
                responsability,
                'ItemDescription',
                null,
              ),
            },
          });
        break;
      case CLAIM.ACCIDENT_DESCRIPTION:
        updateClaim({ ...claimToPreopen, [CLAIM.ACCIDENT_DESCRIPTION]: value });
        props.setDataClaimToUpdate &&
          props.setDataClaimToUpdate({
            ...props.dataClaimToUpdate,
            claim: {
              ...get(props.dataClaimToUpdate, 'claim', {}),
              [CLAIM.ACCIDENT_DESCRIPTION]: value,
            },
          });
        break;

      default:
        return valueStoredClaimToPreopen;
    }

    props.updateFilde &&
      props.updateFilde({
        ...valueStoredClaimToPreopen,
        claim: claimToPreopen,
      });
  };

  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const { message } = displayErrorText(
    props.claimCircumstancesValidation,
    translateArrayErrorMessages(props.claimCircumstancesValidation, true),
  );

  return (
    <Container className="container">
      <Card>
        <CardContent>
          <Typography className="title">
            {translate({ ...messages.claimCircumstancesTitle }, props)}
          </Typography>

          <GridWrapper>
            <Grid container spacing={5}>
              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel ref={inputLabel} id="scaleCase" className="label">
                    {translate({ ...messages.scaleCase }, props)}
                  </InputLabel>
                  <Select
                    name={CLAIM.SCALE_CASE_KEY}
                    value={get(claimToPreopen, [CLAIM.SCALE_CASE_KEY])}
                    onChange={handleChange(CLAIM.SCALE_CASE_KEY)}
                    disabled={
                      !(isValidated && props.isCourtManager
                        ? featureService.hasFeature(
                            FEATURES.UPDATE_CLAIM_COURT_MANAGER,
                          )
                        : true) ||
                      !(isValidated && props.isOpeningManager
                        ? featureService.hasFeature(
                            FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                          )
                        : true)
                    }
                  >
                    {!isEmpty(get(props.listings, 'casDeBareme', [])) &&
                      get(props.listings, 'casDeBareme', []).map(
                        (scaleCase: SagisConfig) => (
                          <MenuItem
                            value={scaleCase.ItemKey}
                            key={scaleCase.ItemKey}
                          >
                            {scaleCase.ItemDescription}
                          </MenuItem>
                        ),
                      )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                {get(claimToPreopen, [CLAIM.SCALE_CASE_KEY]) && (
                  <FormControl fullWidth>
                    <InputLabel
                      ref={inputLabel}
                      id="circumstanceCode"
                      className="label"
                    >
                      {translate({ ...messages.circumstance }, props)}
                    </InputLabel>
                    <Select
                      name={CLAIM.ACCIDENT_CIRCONSTANCE_KEY}
                      value={get(claimToPreopen, [
                        CLAIM.ACCIDENT_CIRCONSTANCE_KEY,
                      ])}
                      onChange={handleChange(CLAIM.ACCIDENT_CIRCONSTANCE_KEY)}
                      disabled={
                        !(isValidated && props.isCourtManager
                          ? featureService.hasFeature(
                              FEATURES.UPDATE_CLAIM_COURT_MANAGER,
                            )
                          : true) ||
                        !(isValidated && props.isOpeningManager
                          ? featureService.hasFeature(
                              FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                            )
                          : true)
                      }
                    >
                      {!isEmpty(getCircumstances()) &&
                        getCircumstances().map((circumstance: SagisConfig) => (
                          <MenuItem
                            value={circumstance.ItemKey}
                            key={circumstance.ItemKey}
                          >
                            {circumstance.ItemDescription}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>
              {isScaleCaseOther ||
                (!isEmpty(claimToPreopen[CLAIM.ACCIDENT_CIRCONSTANCE]) &&
                  /* istanbul ignore next */
                  get(claimToPreopen, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]) && (
                    /* istanbul ignore next */
                    <Grid item xs={3}>
                      <TextField
                        onChange={handleChange(CLAIM.ACCIDENT_CIRCONSTANCE)}
                        name={CLAIM.ACCIDENT_CIRCONSTANCE}
                        value={get(claimToPreopen, [
                          CLAIM.ACCIDENT_CIRCONSTANCE,
                        ])}
                        label={translate(
                          { ...messages.circumstanceDetail },
                          props,
                        )}
                        fullWidth
                        multiline
                        disabled={
                          !(isValidated && props.isCourtManager
                            ? featureService.hasFeature(
                                FEATURES.UPDATE_CLAIM_COURT_MANAGER,
                              )
                            : true) ||
                          !(isValidated && props.isOpeningManager
                            ? featureService.hasFeature(
                                FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                              )
                            : true)
                        }
                      />
                    </Grid>
                  ))}

              <Grid item xs={3}>
                {get(claimToPreopen, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]) && (
                  <FormControl fullWidth>
                    <InputLabel
                      ref={inputLabel}
                      id="responsibility"
                      className="label"
                    >
                      {translate({ ...messages.responsibility }, props)}
                    </InputLabel>
                    <Select
                      name={CLAIM.RESPONSABILITY_KEY}
                      value={get(claimToPreopen, [CLAIM.RESPONSABILITY_KEY])}
                      onChange={handleChange(CLAIM.RESPONSABILITY_KEY)}
                      disabled={!isScaleCaseOther}
                    >
                      {!isEmpty(get(props.listings, 'responsability', [])) &&
                        get(props.listings, 'responsability', []).map(
                          (responsability: SagisConfig) => (
                            <MenuItem
                              value={responsability.ItemKey}
                              key={responsability.ItemKey}
                            >
                              {responsability.ItemDescription}
                            </MenuItem>
                          ),
                        )}
                    </Select>
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={3}>
                {get(claimToPreopen, [CLAIM.RESPONSABILITY_KEY]) && (
                  <TextField
                    id="standard-basic-desc"
                    onChange={handleChange(CLAIM.ACCIDENT_DESCRIPTION)}
                    name={CLAIM.ACCIDENT_DESCRIPTION}
                    value={get(claimToPreopen, [CLAIM.ACCIDENT_DESCRIPTION])}
                    label={translate({ ...messages.description }, props)}
                    fullWidth
                    InputLabelProps={{ shrink: props.inputLabelProps }}
                    multiline
                    error={
                      !!get(props.claimCircumstancesValidation, [
                        CLAIM.ACCIDENT_DESCRIPTION,
                      ])
                    }
                    helperText={message[CLAIM.ACCIDENT_DESCRIPTION]}
                    disabled={
                      !(isValidated && props.isCourtManager
                        ? featureService.hasFeature(
                            FEATURES.UPDATE_CLAIM_COURT_MANAGER,
                          )
                        : true) ||
                      !(isValidated && props.isOpeningManager
                        ? featureService.hasFeature(
                            FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                          )
                        : true)
                    }
                  />
                )}
              </Grid>
            </Grid>
          </GridWrapper>
          <div className="checkdiv">
            <Typography className="text">
              {translate({ ...messages.legalProcedure }, props)}
            </Typography>
            {!props.isRecapPage ||
            isRejected ||
            (props.isCourtManager &&
              featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER)) ||
            (props.isOpeningManager &&
              (isValidated
                ? featureService.hasFeature(
                    FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                  )
                : true)) ? (
              <FormControl>
                <RadioGroup
                  value={get(
                    claimToPreopen,
                    [CLAIM.IS_JUDICIAL_PROCEDURE],
                    get(claimToPreopen, [CLAIM.JUDICIAL_PROCEDURE_ID], '')
                      ? CHOICE.YES
                      : CHOICE.NO,
                  )}
                  onChange={handleChange(CLAIM.IS_JUDICIAL_PROCEDURE)}
                  row
                >
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        value={CHOICE.YES}
                        checkedIcon={<CheckCircle />}
                      />
                    }
                    label={translate({ ...messages.yes }, props)}
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        value={CHOICE.NO}
                        checkedIcon={<CheckCircle />}
                      />
                    }
                    label={translate({ ...messages.no }, props)}
                  />
                </RadioGroup>
                {!!get(props.claimCircumstancesValidation, [
                  CLAIM.IS_JUDICIAL_PROCEDURE,
                ]) && (
                  <FormHelperText className="error">
                    {message[CLAIM.IS_JUDICIAL_PROCEDURE]}
                  </FormHelperText>
                )}
              </FormControl>
            ) : (
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={true}
                    checkedIcon={<CheckCircle />}
                    icon={<RadioButtonUnchecked />}
                    disabled={
                      props.disableInput ||
                      !(isValidated && props.isOpeningManager
                        ? featureService.hasFeature(
                            FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                          )
                        : true) ||
                      !(
                        featureService.hasFeature(
                          FEATURES.UPDATE_CLAIM_COURT_MANAGER,
                        ) && props.isCourtManager
                      )
                    }
                  />
                }
                label={
                  !!get(claimToPreopen, [CLAIM.JUDICIAL_PROCEDURE_ID])
                    ? /* istanbul ignore next */ translate(
                        { ...messages.yes },
                        props,
                      )
                    : translate({ ...messages.no }, props)
                }
              />
            )}
          </div>
          <Collapse
            in={
              !props.isRecapPage ||
              isRejected ||
              props.isCourtManager ||
              props.isOpeningManager
                ? get(
                    claimToPreopen,
                    [CLAIM.IS_JUDICIAL_PROCEDURE],
                    get(claimToPreopen, [CLAIM.JUDICIAL_PROCEDURE_ID], '')
                      ? CHOICE.YES
                      : CHOICE.NO,
                  ) === CHOICE.YES
                : !!get(claimToPreopen, [CLAIM.JUDICIAL_PROCEDURE_ID], '')
            }
          >
            {featureService.hasFeature(FEATURES.COURT_CALENDAR) ? (
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <FormControl>
                    <RadioGroup
                      className="subContainer"
                      aria-label="position"
                      name="position"
                      value={get(
                        claimToPreopen,
                        [CLAIM.JUDICIAL_PROCEDURE_ID],
                        '',
                      )}
                      onChange={handleChange(CLAIM.JUDICIAL_PROCEDURE_ID)}
                      row
                    >
                      {!isEmpty(
                        get(props.listings, 'judicialProcedures', []),
                      ) &&
                        props.listings!.judicialProcedures.map(
                          (procedure: Config) => (
                            <FormControlLabel
                              key={procedure.id}
                              value={procedure.id}
                              classes={{ label: 'radio-label-style' }}
                              control={
                                <Radio
                                  color="primary"
                                  disabled={props.disableInput}
                                />
                              }
                              label={procedure.title}
                              labelPlacement="end"
                              className="input-checkbox"
                            />
                          ),
                        )}
                    </RadioGroup>
                    {!!get(props.claimCircumstancesValidation, [
                      CLAIM.JUDICIAL_PROCEDURE_ID,
                    ]) && (
                      <FormHelperText className="error">
                        {message[CLAIM.JUDICIAL_PROCEDURE_ID]}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <InputLabel className="label">
                      {translate({ ...messages.procedureType }, props)}
                    </InputLabel>
                    <Select
                      labelId="procedure_nature-label-id"
                      name={CLAIM.PROCEDURE_NATURE_ID}
                      value={get(
                        claimToPreopen,
                        [CLAIM.PROCEDURE_NATURE_ID],
                        '',
                      )}
                      disabled
                    >
                      {!isEmpty(get(props.listings, 'procedureNature', [])) &&
                        get(props.listings, 'procedureNature', []).map(
                          (el: Config) => (
                            <MenuItem key={el.id} value={String(el.id)}>
                              {el.title}
                            </MenuItem>
                          ),
                        )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <TextField
                      id="court-number"
                      name={CLAIM.COURT_NUMBER}
                      value={get(claimToPreopen, [CLAIM.COURT_NUMBER])}
                      label={translate({ ...messages.courtNumber }, props)}
                      fullWidth
                      InputLabelProps={{ shrink: props.inputLabelProps }}
                      multiline
                      disabled
                    />
                  </FormControl>
                </Grid>
              </Grid>
            ) : (
              <FormControl>
                <RadioGroup
                  className="subContainer"
                  aria-label="position"
                  name="position"
                  value={get(claimToPreopen, [CLAIM.JUDICIAL_PROCEDURE_ID], '')}
                  onChange={handleChange(CLAIM.JUDICIAL_PROCEDURE_ID)}
                  row
                >
                  {!isEmpty(get(props.listings, 'judicialProcedures', [])) &&
                    props.listings!.judicialProcedures.map(
                      (procedure: Config) => (
                        <FormControlLabel
                          key={procedure.id}
                          value={procedure.id}
                          classes={{ label: 'radio-label-style' }}
                          control={
                            <Radio
                              color="primary"
                              disabled={props.disableInput}
                            />
                          }
                          label={procedure.title}
                          labelPlacement="end"
                          className="input-checkbox"
                        />
                      ),
                    )}
                </RadioGroup>
                {!!get(props.claimCircumstancesValidation, [
                  CLAIM.JUDICIAL_PROCEDURE_ID,
                ]) && (
                  <FormHelperText className="error">
                    {message[CLAIM.JUDICIAL_PROCEDURE_ID]}
                  </FormHelperText>
                )}
              </FormControl>
            )}
          </Collapse>
          {featureService.hasFeature(FEATURES.COURT_CALENDAR) && (
            <>
              <div className="checkdiv">
                <Typography className="text">
                  {translate({ ...messages.provisionalClaim }, props)}
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={true}
                      checkedIcon={<CheckCircle />}
                      icon={<RadioButtonUnchecked />}
                      disabled={
                        props.disableInput ||
                        !(isValidated && props.isOpeningManager
                          ? featureService.hasFeature(
                              FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                            )
                          : true) ||
                        !(
                          featureService.hasFeature(
                            FEATURES.UPDATE_CLAIM_COURT_MANAGER,
                          ) && props.isCourtManager
                        )
                      }
                    />
                  }
                  label={
                    !!get(claimToPreopen, [CLAIM.PROVISIONAL_CLAIM_REFERENCE])
                      ? translate({ ...messages.yes }, props)
                      : translate({ ...messages.no }, props)
                  }
                />
              </div>
              <Collapse
                in={
                  !!get(claimToPreopen, [CLAIM.PROVISIONAL_CLAIM_REFERENCE], '')
                }
              >
                <TextField
                  id="provisional-claim-reference"
                  label={translate(
                    { ...messages.provisionalClaimReference },
                    props,
                  )}
                  name={CLAIM.PROVISIONAL_CLAIM_REFERENCE}
                  value={get(claim, [CLAIM.PROVISIONAL_CLAIM_REFERENCE], '')}
                  fullWidth
                  disabled
                  InputLabelProps={{ shrink: props.inputLabelProps }}
                  multiline
                  style={{ width: 250 }}
                />
              </Collapse>
            </>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};
export default injectIntl(LawyerClaimCircumstances);
